import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';

/*
  Generated class for the ProductsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ListasProvider {
    apiBase = baseUrlFunc() + "wp/v2/listas"

    constructor(public http: HttpInterceptorProvider) {
        console.log('Hello ProductsProvider Provider');
    }

    requestAllLists(): Observable<any> {
        return Observable.create(observer => {

            let lastUpdateInMilli = this.getLastUpdate()
            let nowInMilli = Date.now()
            let one_hour_in_milli = 1000 * 60 * 60 * 24 //milli * seconds * minutes

            if (lastUpdateInMilli != undefined &&
                (nowInMilli - lastUpdateInMilli) < one_hour_in_milli) {

                var object = {
                    especialidades_medico: this.getSpecialities(),
                    areas_interesse: this.getInterest(),
                    assuntos_email: this.getEmailSubjects(),
                    estados: this.getStates(),
                    opcoes_contato: ["Telefone", "E-mail"]
                }

                observer.next(object)

            } else {

                this.http.get(this.apiBase).subscribe(data => {
                    debugger;
                    if (data != null && data.length > 0) {

                        var object = {
                            especialidades_medico: data[0].acf.especialidades_medico,
                            areas_interesse: data[0].acf.areas_interesse,
                            assuntos_email: data[0].acf.assuntos_email,
                            estados: this.getStates(),
                            opcoes_contato: ["Telefone", "E-mail"]
                        }

                        this.persistSpecialities(object.especialidades_medico)
                        this.persistInterest(object.areas_interesse)
                        this.persistEmailSubjects(object.assuntos_email)
                        this.persistLastUpdate()
                        observer.next(object)
                    } else {
                        observer.error()
                    }
                }, err => {
                    observer.error("Você parece estar desconectado, por favor verifique sua conexão e tente novamente.")
                })
            }
        })
    }


    persistSpecialities(espec: any) {
        window.localStorage.setItem("Spec", JSON.stringify(espec))
    }
    persistInterest(interest: any) {
        window.localStorage.setItem("Inte", JSON.stringify(interest))
    }
    persistEmailSubjects(subJects: any) {
        window.localStorage.setItem("SubJects", JSON.stringify(subJects))
    }

    persistLastUpdate() {
        window.localStorage.setItem("LastUpdate", JSON.stringify(Date.now()))
    }

    getSpecialities(): Array<string> {
        var string = window.localStorage.getItem("Spec")
        debugger
        return JSON.parse(string)
    }
    getInterest(): Array<string> {
        var string = window.localStorage.getItem("Inte")
        return JSON.parse(string)
    }
    getEmailSubjects(): Array<string> {
        var string = window.localStorage.getItem("SubJects")
        return JSON.parse(string)
    }

    getLastUpdate(): number {
        var string = window.localStorage.getItem("LastUpdate")
        return JSON.parse(string)
    }


    getStates() {
        return [{
            "ID": "1",
            "Sigla": "AC",
            "Nome": "Acre"
        },
        {
            "ID": "2",
            "Sigla": "AL",
            "Nome": "Alagoas"
        },
        {
            "ID": "3",
            "Sigla": "AM",
            "Nome": "Amazonas"
        },
        {
            "ID": "4",
            "Sigla": "AP",
            "Nome": "Amapá"
        },
        {
            "ID": "5",
            "Sigla": "BA",
            "Nome": "Bahia"
        },
        {
            "ID": "6",
            "Sigla": "CE",
            "Nome": "Ceará"
        },
        {
            "ID": "7",
            "Sigla": "DF",
            "Nome": "Distrito Federal"
        },
        {
            "ID": "8",
            "Sigla": "ES",
            "Nome": "Espírito Santo"
        },
        {
            "ID": "9",
            "Sigla": "GO",
            "Nome": "Goiás"
        },
        {
            "ID": "10",
            "Sigla": "MA",
            "Nome": "Maranhão"
        },
        {
            "ID": "11",
            "Sigla": "MG",
            "Nome": "Minas Gerais"
        },
        {
            "ID": "12",
            "Sigla": "MS",
            "Nome": "Mato Grosso do Sul"
        },
        {
            "ID": "13",
            "Sigla": "MT",
            "Nome": "Mato Grosso"
        },
        {
            "ID": "14",
            "Sigla": "PA",
            "Nome": "Pará"
        },
        {
            "ID": "15",
            "Sigla": "PB",
            "Nome": "Paraíba"
        },
        {
            "ID": "16",
            "Sigla": "PE",
            "Nome": "Pernambuco"
        },
        {
            "ID": "17",
            "Sigla": "PI",
            "Nome": "Piauí"
        },
        {
            "ID": "18",
            "Sigla": "PR",
            "Nome": "Paraná"
        },
        {
            "ID": "19",
            "Sigla": "RJ",
            "Nome": "Rio de Janeiro"
        },
        {
            "ID": "20",
            "Sigla": "RN",
            "Nome": "Rio Grande do Norte"
        },
        {
            "ID": "21",
            "Sigla": "RO",
            "Nome": "Rondônia"
        },
        {
            "ID": "22",
            "Sigla": "RR",
            "Nome": "Roraima"
        },
        {
            "ID": "23",
            "Sigla": "RS",
            "Nome": "Rio Grande do Sul"
        },
        {
            "ID": "24",
            "Sigla": "SC",
            "Nome": "Santa Catarina"
        },
        {
            "ID": "25",
            "Sigla": "SE",
            "Nome": "Sergipe"
        },
        {
            "ID": "26",
            "Sigla": "SP",
            "Nome": "São Paulo"
        },
        {
            "ID": "27",
            "Sigla": "TO",
            "Nome": "Tocantins"
        }]
    }
}



// WEBPACK FOOTER //
// ./src/providers/listas/listas.ts